import { context } from "../../context";


/**
 * Enthält Informationen über den Authentifizierungs-Zustand. Aktuell stammen
 * die Informationen aus der context.js (=> context.jsc) 
 */
const module = {
    namespaced: true,
    state: {
        isLoggedIn: context.userName !== null,
        loginMessage: "Du scheinst Entwickler zu sein... Öffne einen neuen Tab, melde dich dort in MathCoach an und versuche anschließend hier weiter zu arbeiten, indem du die Seite neu lädst.", // "Zu lange inaktiv, ...."

        userName: context.userName,
        isAdmin: context.isAdmin,
        isAuthor: context.isAuthor,
        // isDeveloper: false, // TODO: rolle serverseitig einführen 
    },
    mutations: {
        ["LOGOUT"] (state, message) {
            state.isLoggedIn = false;
            state.loginMessage = message;

            state.userName = null;
            state.isAdmin = false;
            state.isAuthor = false;
        }
    },
    actions: {
        async logout( { commit }, message) {
            commit("LOGOUT", message);
        },
    },
    getters: {
    }
};

export default module;
